export default __webpack_public_path__ + "static/token-chart-f126063cf6cf464dd9259ade9974cd0a.png";